import { render } from "./NftCardComp.vue?vue&type=template&id=1e5a480d&ts=true"
import script from "./NftCardComp.vue?vue&type=script&lang=ts"
export * from "./NftCardComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__